module.exports = __webpack_public_path__ + "img/ape-constructor-star-stroke.46d76824.svg";